import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ShareLinkIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#share-link__a)",
                            children: _jsx("path", {
                                d: "M18.765 14.18c-1.22 0-2.38.48-3.24 1.34-.11.11-.2.24-.3.36l-5.56-2.79c.09-.36.15-.72.15-1.09 0-.37-.06-.74-.15-1.09l5.56-2.79c.1.12.18.25.3.36.87.87 2.02 1.34 3.24 1.34 1.22 0 2.38-.48 3.24-1.34.87-.87 1.34-2.02 1.34-3.24 0-1.22-.48-2.37-1.34-3.24a4.546 4.546 0 00-3.24-1.34c-1.22 0-2.38.48-3.24 1.34-.87.87-1.34 2.02-1.34 3.24 0 .38.06.74.15 1.09l-5.56 2.79c-.1-.12-.18-.25-.3-.36a4.546 4.546 0 00-3.24-1.34c-1.22 0-2.38.48-3.24 1.34-.87.87-1.34 2.02-1.34 3.24 0 1.22.49 2.39 1.34 3.24.87.87 2.02 1.34 3.24 1.34 1.22 0 2.37-.48 3.24-1.34.11-.11.2-.24.3-.36l5.56 2.79c-.09.36-.15.72-.15 1.09 0 1.22.48 2.38 1.34 3.24a4.57 4.57 0 003.24 1.34c1.22 0 2.38-.48 3.24-1.34a4.587 4.587 0 000-6.48 4.529 4.529 0 00-3.24-1.34zM16.935 3.4c.49-.49 1.14-.76 1.83-.76.69 0 1.34.27 1.83.76s.76 1.14.76 1.83c0 .69-.27 1.34-.76 1.83-.98.98-2.68.98-3.65 0-.49-.49-.76-1.14-.76-1.83 0-.69.27-1.34.76-1.83h-.01zM3.405 13.83c-.48-.48-.76-1.15-.76-1.83 0-.68.27-1.34.76-1.83s1.14-.76 1.83-.76c.69 0 1.34.27 1.83.76s.76 1.14.76 1.83c0 .69-.28 1.35-.76 1.83-.98.97-2.68.97-3.65 0h-.01zm17.19 6.77c-.97.97-2.68.97-3.65 0-.49-.49-.76-1.14-.76-1.83 0-.69.27-1.34.76-1.83s1.14-.76 1.83-.76c.69 0 1.34.27 1.83.76s.76 1.14.76 1.83c0 .69-.27 1.34-.76 1.83h-.01z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "share-link__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
ShareLinkIcon.isCarinaIcon = true;
export default ShareLinkIcon;
